import MicIcon from '@assets/svgs/mic.svg'
import {Center, Image, Spinner} from '@chakra-ui/react'
import Lottie from 'lottie-react'
import {useEffect, forwardRef, useImperativeHandle, useState} from 'react'
import * as animationData from '@assets/lotties/mic.json'
import {useRecord} from '@hooks/useRecord'

// Nên định nghĩa interface cho props
interface GlobalMic3Props {
  isDisabled?: boolean
  isLoading?: boolean
  handleStartRecording?: () => void
  handleRecordingComplete: (recordingBlob: Blob) => void
}

const baseStyles = {
  width: '100px',
  height: '64px',
  borderRadius: '64px',
}

const gradientStyles = {
  default: 'linear-gradient(180deg, #00D1FF 0%, #00A3FF 100%)',
  hover: 'linear-gradient(180deg, #00BBE6 0%, #0091E6 100%)',
  disabled: '#BFBFBF',
  recording: 'linear-gradient(335deg, #FFA800 15.35%, #FFC34F 88.09%)',
}

const GlobalMic3 = (
  {
    isDisabled = false,
    isLoading = false,
    handleStartRecording = () => {},
    handleRecordingComplete,
  }: GlobalMic3Props,
  ref: any,
) => {
  const [isRecording, recordingBlob, startRecording, stopRecording] =
    useRecord()
  const [isTriggerComplete, setIsTriggerComplete] = useState(true)

  useEffect(() => {
    if (!recordingBlob || !isTriggerComplete) return
    handleRecordingComplete(recordingBlob)

    return () => {
      if (isRecording) {
        stopRecording()
      }
    }
  }, [recordingBlob])

  const handleClickMic = () => {
    if (isLoading && isDisabled) return
    if (isRecording) {
      stopRecording()
    } else {
      setIsTriggerComplete(true)
      handleStartRecording()
      startRecording()
    }
  }

  const getMicStatus = () => {
    return isRecording
  }

  const handleStopRecording = () => {
    setIsTriggerComplete(false)
    stopRecording()
  }

  useImperativeHandle(
    ref,
    () => ({
      getMicStatus,
      handleStopRecording,
      handleClickMic,
    }),
    [getMicStatus, handleStopRecording, handleClickMic],
  )

  return (
    <Center
      {...baseStyles}
      cursor={'pointer'}
      pointerEvents={isDisabled || isLoading ? 'none' : 'unset'}
      bg={
        isDisabled
          ? gradientStyles.disabled
          : isRecording
            ? gradientStyles.recording
            : gradientStyles.default
      }
      _hover={{
        bg: !isRecording ? gradientStyles.hover : gradientStyles.recording,
      }}
      onClick={handleClickMic}>
      {isLoading ? (
        <Spinner color="white" size="md" />
      ) : isRecording ? (
        <Lottie animationData={animationData} />
      ) : (
        <Image src={MicIcon} />
      )}
    </Center>
  )
}

export default forwardRef(GlobalMic3)
